import React from 'react';
import { useRouter } from 'next/router';
import { lighten } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

const announcementTexts = {
  'en-US': 'State of AI Apps Report 2025 is Live!',
  ja: '当社はPlaylinerを買収しました。',
  ko: '센서타워가 Playliner를 인수했습니다!',
  'zh-CN': '我们已收购 Playliner！',
} as const;
const linkTexts = {
  'en-US': 'Download Now',
  ja: '新しいライブオペレーションサービスについての詳細はこちら',
  ko: '새로운 라이브옵스 서비스에 대해 자세히 알아보세요!',
  'zh-CN': '点击此处了解我们新的 Live Ops 产品！',
} as const;
const queryStrings = {
  'en-US': '',
  ja: '',
  ko: '',
  'zh-CN': '',
} as const;
const linkHrefs = {
  'en-US': '/report/state-of-ai-apps-2025',
  ja: '/ja/blog/playliner-acquisition',
  ko: '/ko/blog/playliner-acquisition',
  'zh-CN': '/zh-CN/blog/playliner-acquisition',
} as const;

export const AnnouncementBanner = () => {
  const { locale, asPath } = useRouter();

  // @ts-expect-error - TS doesn't know that the locale is a string
  const announcementText = announcementTexts[locale] || announcementTexts['en-US'];
  // @ts-expect-error - TS doesn't know that the locale is a string
  const linkText = linkTexts[locale] || linkTexts['en-US'];
  // @ts-expect-error - TS doesn't know that the locale is a string
  const queryString = queryStrings[locale] || queryStrings['en-US'];
  // @ts-expect-error - TS doesn't know that the locale is a string
  const linkHref = (linkHrefs[locale] || linkHrefs['en-US']) + queryString;

  const currentPath = asPath.split('?')[0];
  const trimmedPath = currentPath.replace(/\/+$/, '');
  // Remove the first empty segments created by the leading slash and possible trailing slash
  const pathSegments = trimmedPath.split('/').filter((segment) => segment !== '');

  const isCurrentPageSameAsLink = currentPath === linkHref;
  const isInfogramReportPage = pathSegments.at(0) === 'report';

  // Don't show the banner on the page it links to or on Infogram landing and download report pages.
  if (isCurrentPageSameAsLink || isInfogramReportPage) {
    return null;
  }

  return (
    <Grid
      container
      direction={{ xs: 'column', md: 'row' }}
      bgcolor="blue.main"
      sx={[
        {
          minHeight: 64,
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: 0, md: 2 },
        },
        (theme) => ({
          [theme.breakpoints.down('xs')]: { fontSize: 16 },
        }),
      ]}
    >
      <Grid item>
        <Typography variant="body1" color="blue.contrastText" sx={{ fontWeight: 600 }}>
          {announcementText}
        </Typography>
      </Grid>

      <Grid item>
        <a href={linkHref}>
          <Typography
            variant="body1"
            color="teal.main"
            sx={[
              { fontWeight: 600 },
              (theme) => ({
                '&:hover': {
                  color: lighten(theme.palette.teal.main, 0.4),
                },
              }),
            ]}
          >
            {linkText}
          </Typography>
        </a>
      </Grid>
    </Grid>
  );
};

export default AnnouncementBanner;
